export default "Boardgame Breakout er en del af den lille brætspilscafé Nerd Cave.";